{
  "surface-primary": "var(--ds-color-surface-primary)",
  "surface-highlight": "var(--ds-color-surface-highlight)",
  "surface-game-badge-error": "var(--ds-color-surface-game-badge-error)",
  "surface-game-badge-success": "var(--ds-color-surface-game-badge-success)",
  "surface-highlight-text": "var(--ds-color-surface-highlight-text)",
  "surface-primary-raised-soft": "var(--ds-color-surface-primary-raised-soft)",
  "surface-primary-raised-strong": "var(--ds-color-surface-primary-raised-strong)",
  "surface-primary-elevated": "var(--ds-color-surface-primary-elevated)",
  "surface-primaryinvert": "var(--ds-color-surface-primaryinvert)",
  "surface-foreground": "var(--ds-color-surface-foreground)",
  "surface-foreground-native": "var(--ds-color-surface-foreground-native)",
  "surface-primaryinvert-raised-soft": "var(--ds-color-surface-primaryinvert-raised-soft)",
  "surface-primaryinvert-elevated": "var(--ds-color-surface-primaryinvert-elevated)",
  "surface-brand": "var(--ds-color-surface-brand)",
  "surface-success": "var(--ds-color-surface-success)",
  "surface-culture": "var(--ds-color-surface-culture)",
  "surface-breaking": "var(--ds-color-surface-breaking)",
  "surface-overlay": "var(--ds-color-surface-overlay)",
  "surface-native": "var(--ds-color-surface-native)",
  "surface-native-subtle": "var(--ds-color-surface-native-subtle)",
  "surface-quiz": "var(--ds-color-surface-quiz)",
  "surface-media": "var(--ds-color-surface-media)",
  "border-primary": "var(--ds-color-border-primary)",
  "border-primary-strong": "var(--ds-color-border-primary-strong)",
  "border-primary-strongest": "var(--ds-color-border-primary-strongest)",
  "border-primaryinvert": "var(--ds-color-border-primaryinvert)",
  "border-primaryinvert-strong": "var(--ds-color-border-primaryinvert-strong)",
  "border-primaryinvert-strongest": "var(--ds-color-border-primaryinvert-strongest)",
  "border-brand": "var(--ds-color-border-brand)",
  "border-culture": "var(--ds-color-border-culture)",
  "text-primary": "var(--ds-color-text-primary)",
  "text-primary-subtle": "var(--ds-color-text-primary-subtle)",
  "text-primary-disabled": "var(--ds-color-text-primary-disabled)",
  "text-primaryinvert": "var(--ds-color-text-primaryinvert)",
  "text-primaryinvert-subtle": "var(--ds-color-text-primaryinvert-subtle)",
  "text-primaryinvert-disabled": "var(--ds-color-text-primaryinvert-disabled)",
  "text-brand": "var(--ds-color-text-brand)",
  "text-culture": "var(--ds-color-text-culture)",
  "text-critical": "var(--ds-color-text-critical)",
  "text-success": "var(--ds-color-text-success)",
  "text-on-brand": "var(--ds-color-text-on-brand)",
  "text-body-link": "var(--ds-color-text-body-link)",
  "text-body-link-visited": "var(--ds-color-text-body-link-visited)",
  "gradients-primary-start": "var(--ds-color-gradients-primary-start)",
  "gradients-primary-end": "var(--ds-color-gradients-primary-end)",
  "gradients-overlay-start": "var(--ds-color-gradients-overlay-start)",
  "gradients-overlay-end": "var(--ds-color-gradients-overlay-end)",
  "button-primary-bg-default": "var(--ds-color-button-primary-bg-default)",
  "button-primary-bg-hover": "var(--ds-color-button-primary-bg-hover)",
  "button-primary-bg-pressed": "var(--ds-color-button-primary-bg-pressed)",
  "button-primary-bg-disabled": "var(--ds-color-button-primary-bg-disabled)",
  "button-primary-black-bg-default": "var(--ds-color-button-primary-black-bg-default)",
  "button-primary-black-bg-hover": "var(--ds-color-button-primary-black-bg-hover)",
  "button-primary-black-bg-pressed": "var(--ds-color-button-primary-black-bg-pressed)",
  "button-primary-black-bg-disabled": "var(--ds-color-button-primary-black-bg-disabled)",
  "button-secondary-filled-bg-default": "var(--ds-color-button-secondary-filled-bg-default)",
  "button-secondary-filled-bg-hover": "var(--ds-color-button-secondary-filled-bg-hover)",
  "button-secondary-filled-bg-pressed": "var(--ds-color-button-secondary-filled-bg-pressed)",
  "button-secondary-filled-bg-disabled": "var(--ds-color-button-secondary-filled-bg-disabled)",
  "button-secondary-outline-outline-default": "var(--ds-color-button-secondary-outline-outline-default)",
  "button-secondary-outline-outline-hover": "var(--ds-color-button-secondary-outline-outline-hover)",
  "button-secondary-outline-outline-pressed": "var(--ds-color-button-secondary-outline-outline-pressed)",
  "button-secondary-outline-bg-disabled": "var(--ds-color-button-secondary-outline-bg-disabled)",
  "button-game-on-bg-default": "var(--ds-color-button-game-on-bg-default)",
  "button-game-bg-error": "var(--ds-color-button-game-bg-error)",
  "button-game-on-bg-hover": "var(--ds-color-button-game-on-bg-hover)",
  "button-game-on-bg-pressed": "var(--ds-color-button-game-on-bg-pressed)",
  "button-game-on-text-default": "var(--ds-color-button-game-on-text-default)",
  "button-game-on-outline-default": "var(--ds-color-button-game-on-outline-default)",
  "button-game-off-bg-default": "var(--ds-color-button-game-off-bg-default)",
  "button-game-off-bg-hover": "var(--ds-color-button-game-off-bg-hover)",
  "button-game-off-bg-pressed": "var(--ds-color-button-game-off-bg-pressed)",
  "button-game-off-text-default": "var(--ds-color-button-game-off-text-default)",
  "button-game-off-outline-default": "var(--ds-color-button-game-off-outline-default)",
  "button-game-hint-bg-default": "var(--ds-color-button-game-hint-bg-default)",
  "button-game-hint-outline-default": "var(--ds-color-button-game-hint-outline-default)",
  "button-game-hint-text-default": "var(--ds-color-button-game-hint-text-default)",
  "brand-100": "var(--ds-color-brand-100)",
  "brand-200": "var(--ds-color-brand-200)",
  "brand-300": "var(--ds-color-brand-300)",
  "brand-400": "var(--ds-color-brand-400)",
  "brand-500": "var(--ds-color-brand-500)",
  "brand-600": "var(--ds-color-brand-600)",
  "brand-700": "var(--ds-color-brand-700)",
  "brand-800": "var(--ds-color-brand-800)",
  "brand-900": "var(--ds-color-brand-900)",
  "brand-050": "var(--ds-color-brand-050)",
  "culture-0": "var(--ds-color-culture-0)",
  "culture-100": "var(--ds-color-culture-100)",
  "culture-200": "var(--ds-color-culture-200)",
  "culture-300": "var(--ds-color-culture-300)",
  "culture-400": "var(--ds-color-culture-400)",
  "culture-500": "var(--ds-color-culture-500)",
  "culture-600": "var(--ds-color-culture-600)",
  "culture-700": "var(--ds-color-culture-700)",
  "culture-800": "var(--ds-color-culture-800)",
  "culture-900": "var(--ds-color-culture-900)",
  "culture-1000": "var(--ds-color-culture-1000)",
  "culture-1100": "var(--ds-color-culture-1100)",
  "neutral-100": "var(--ds-color-neutral-100)",
  "neutral-200": "var(--ds-color-neutral-200)",
  "neutral-300": "var(--ds-color-neutral-300)",
  "neutral-400": "var(--ds-color-neutral-400)",
  "neutral-500": "var(--ds-color-neutral-500)",
  "neutral-600": "var(--ds-color-neutral-600)",
  "neutral-700": "var(--ds-color-neutral-700)",
  "neutral-800": "var(--ds-color-neutral-800)",
  "neutral-900": "var(--ds-color-neutral-900)",
  "neutral-1000": "var(--ds-color-neutral-1000)",
  "neutral-1100": "var(--ds-color-neutral-1100)",
  "neutral-white": "var(--ds-color-neutral-white)",
  "neutral-050": "var(--ds-color-neutral-050)",
  "neutral-black": "var(--ds-color-neutral-black)"
}